import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Vehicle, Email, Closed } from "../../common/imagePath";
import { AppContext } from "../../context/AppContext";

function ReceivingCard({ data, onCancel, visible, callback }) {

  const [showEdit, setShowEdit] = useState(false);
  const [newData, setNewData] = useState(data);
  
  //accordian

  const [isAccordionOpen, setAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };

  //////

  let supplierAddress =
    newData?.Address1 +
    " " +
    newData?.Address2 +
    ", " +
    newData?.City +
    ", " +
    newData?.State +
    ", " +
    newData?.Country +
    ". " +
    newData?.Zip;

  
  const [mailingAddress, setMailingAddress] = useState(supplierAddress);
  const [valueOfInput, setValueOfInput] = useState(supplierAddress);

  const { updateMail } = useContext(AppContext);

  useEffect(() => {
    setNewData(data);
    setMailingAddress(supplierAddress);
  }, [data, supplierAddress]);

  //  console.log(valueOfInput);
  const handleClick = () => {
    setValueOfInput(mailingAddress);
    setShowEdit(true);
  };

  const handleAddress = (e) => {
    setValueOfInput(e?.target?.value);
    // setAddValue(e.target.value);
    // setShowEdit(true);
    callback(e?.target?.value);
  };

  const AddAddress = (e) => {
    // setValueOfInput(valueOfInput);

    setMailingAddress(valueOfInput);

    setShowEdit(false);

    // updateMail(valueOfInput)

    // callback(valueOfInput);
  };
  // const { onCancel } = props;
  // console.log("props>>>>>", props);
  // const [mailingAddress, setMailingAddress] = useState(props.value.address);

  // let supplierData = data;

  // const handleMailingAddressChange = (event) => {
  //   setMailingAddress(event.target.value);
  // };

  
  return (
    <>
      <div className="card custom-card mb-3">
        <div 
        // className="card-body" 
        style={{ borderTop: "1px solid #e9ecef" }}>
          <div className=""
          style={{padding:"10px"}}
          >
            <div className="row">
              {/* <div className="position-relative">
                <Link
                  className="position-absolute top-0 end-0 me-2"
                  to={`/manage-suppliers/${data.Id}`}
                >
                  <i
                    className="fa fa-edit text-warning fa-2x "
                    title="Edit"
                  ></i>
                </Link>
              </div> */}

              <div className="col-md-2">
                <img
                  src={data.Image}
                  onError={(e) => {
                    e.currentTarget.src =
                      "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                  }}
                  //alt={props.Name}
                  className="img-thumbnail rounded-circle mr-5"
                  width="100px"
                  height="105px"
                />
              </div>

              <div className="col-10">
                <Link to={`/manage-suppliers/${data.ID}`} title="Edit">
                  <span style={{ fontSize: "15px" }}>
                    {data.FirstName} {data.LastName} ({data.CompanyName})
                  </span>{" "}
                </Link>
                <br></br>
                <span
                  className="text-success text-bold"
                  style={{ fontSize: "15px" }}
                >
                  Balance: {data.Balance}
                </span>
                <br></br>
                <span> {data.Email}</span>
                <br></br>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <span>
                  {showEdit ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                      }}
                    >
                      <input
                        id="MailingAddress"
                        name="MailingAddress"
                        placeholder="Mailing Address"
                        className="form-control w-100"
                        style={{ border: "none" }}
                        value={valueOfInput}
                        defaultValue={data.Address1}
                        // onChange={(e) => setValueOfInput(e.target.value)}
                        onChange={(e) => handleAddress(e)}
                      ></input>
                      <button
                        className="btn btn-outline-primary btn-sm m-1"
                        onClick={() => AddAddress()}
                      >
                        <i className="fa fa-check" aria-hidden="true"></i>
                      </button>
                      <button
                        className="btn btn-outline-danger btn-sm m-1"
                        onClick={() => setShowEdit(false)}
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </button>
                    </div>
                  ) : (
                    // <div>
                    //   <p>
                    //     <i
                    //       className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                    //       style={{ fontSize: "16px" }}
                    //     ></i>
                    //     {mailingAddress}
                    //     &nbsp;&nbsp;
                    //     <i
                    //       className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                    //       style={{ fontSize: "16px", cursor: "pointer" }}
                    //       onClick={handleClick}
                    //     ></i>
                    //   </p>
                    // </div>
                    <>
                    {/* <hr/> */}
                    <div className="accordion-item">
                      <div className="accordion-header" style={{ cursor: "pointer" }} onClick={toggleAccordion}>
                        {/* <button
                          type="button"
                          className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding col-md-12"
                          >
                          Mailing Address
                        </button> */}
                        <button class="accordion-button dropdown-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          Billing Address
                        </button>
                      </div>
                      {isAccordionOpen && (
                        <div className="accordion">
                          <p>
                            <i className="fa fa-map-marker text-danger fa-1x ml-2 p-2" style={{ fontSize: '16px' }}></i>
                            {mailingAddress}
                            &nbsp;&nbsp;
                            <i
                              className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                              style={{ fontSize: '16px', cursor: 'pointer' }}
                              onClick={handleClick}
                            ></i>
                          </p>
                        </div>
                      )}
                    </div>
                    {/* <hr/> */}
                    </>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer p-0">
          <div className="row">
            <div
              className="col-md-6  text-center"
              style={{ padding: "5px 0px" }}
            >
              <Link to={`/manage-suppliers/${data.Id}`} title="Edit">
                <span>Update Supplier</span>
              </Link>
            </div>

            <div
              className="col-md-6 text-center"
              style={{ borderLeft: "1px solid #ccc", padding: "5px 0px" }}
            >
              <Link
                type="button"
                onClick={onCancel}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <img
                  src={Closed}
                  style={{
                    marginRight: "0.5rem",
                    width: "0.9rem",
                    height: "0.9rem",
                  }}
                /> */}
                <span>Detach</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReceivingCard;
